import { StarIcon } from 'lucide-react';
type Props = {
  /** 0–5; wordt afgerond op hele sterren. */
  value: number;
  className?: string;
};

/**
 * Vijf sterren, de lege gedempt: zo lees je "4 van 5" in één oogopslag. Decoratief; de
 * omringende tekst (of een sr-only regel) zegt het cijfer hardop.
 */
export function Stars({
  value,
  className = 'h-3.5 w-3.5'
}: Props) {
  const filled = Math.round(value);
  return <span className="flex gap-0.5" aria-hidden="true" data-id="element-8763" data-mp="1ceiumt15rmkw">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className={`${className} fill-current ${i < filled ? 'text-clay' : 'text-ink/15'}`} strokeWidth={0} data-id="element-8764" data-mp="1h60wrkex3t7g" data-mpi={i} />)}
    </span>;
}